module.exports = __webpack_public_path__ + "static/media/talkmore-icons.c40b55f5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/talkmore-icons.woff
// module id = 119
// module chunks = 0